import { render } from "./CvCardKansai01.vue?vue&type=template&id=0f18b64b&scoped=true"
import script from "./CvCardKansai01.vue?vue&type=script&lang=js"
export * from "./CvCardKansai01.vue?vue&type=script&lang=js"

import "./CvCardKansai01.vue?vue&type=style&index=0&id=0f18b64b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f18b64b"]])

export default __exports__